import StandsGlobalFiltersForm from "./stands-global-filters-form";

const StandsGlobalForms = {
    Filter: StandsGlobalFiltersForm,
}

export default StandsGlobalForms;
